import { HttpResult } from "widgets-for-react";
import { SubscriptionData } from "../../sharepointPageApi/types/pageData";

export const allSubscriptionsBlockApi = async (): Promise<HttpResult<SubscriptionData[]>> => {
    const res = await fetch(`/api/v1/lists/subscriptions`);

    if (!res.ok)
      return {
        kind: 'failed',
        status: res.status,
      }

    const data: SubscriptionData[] = await res.json();

    return {
      kind: 'result',
      status: 200,
      value: data,
    };
  }
